import { HANDLE_CHANGE_INTELLIGENCE_DATE_CONTROLS } from './../actions/intelligenceDateControlsActions'

const initialState = {
  isDateControlsOpen: true
}

const intelligenceDateControlsReducer = (state = initialState, action) => {
  switch (action.type) {
    case HANDLE_CHANGE_INTELLIGENCE_DATE_CONTROLS: {
      return Object.assign(
        {},
        state,
        {
          isDateControlsOpen: action.data
        }
      )
    }
    default:
      return state
  }
}

export default intelligenceDateControlsReducer